import { render, staticRenderFns } from "./CollectionCheckCard.vue?vue&type=template&id=6c391e5d&"
import script from "./CollectionCheckCard.vue?vue&type=script&lang=js&"
export * from "./CollectionCheckCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports